import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/Login.vue'),
    meta: { guest: true },
  },
  {
    path: '/',
    component: () => import('@/layouts/AdminLayout.vue'),
    children: [
      { path: 'internal-iam', name: 'internal-iam', component: () => import('@/pages/InternalIam.vue'), meta: { platformAdmin: true } },
      {
        path: '',
        name: 'organizations',
        component: () => import('@/pages/Organizations.vue'),
        meta: { platformAdmin: true },
      },
      {
        path: 'organizations',
        redirect: { name: 'organizations' },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'organizations' },
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();
  await auth.initializeAuth();

  if (to.meta.guest) {
    return auth.isPlatformAdmin ? { name: 'organizations' } : true;
  }

  if (!auth.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } };
  }

  if (to.meta.platformAdmin && !auth.isPlatformAdmin) {
    await auth.logout();
    return { name: 'login' };
  }

  return true;
});
